import React, { useContext, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import style from "./SessionListContainerHorizontal.module.sass";
import { PersonalSequencePageContext } from "../PersonalSequencePage";
import { callApi } from "../../../helpers";

function SessionListContainerHorizontal(props) {
  const { state, setState, refresh, type, months } = useContext(PersonalSequencePageContext);
  const { personalSequences, rental } = state;
  const isReacts = type == ('reacts_personal_sequence' || 'reacts_saved_sequence')

  const clickOnSession = (id, addId) => {
    const newState = JSON.parse(JSON.stringify(state));
    let newSelected = [...newState.newSessionForm.indexes];
    if (addId) {
      newSelected.push(id);
    } else {
      newSelected = newSelected.filter((item) => item !== id);
    }

    if (newSelected.length > 0) {
      newState.newSessionForm.state = "adding";
    } else {
      newState.newSessionForm.state = "instructions";
    }
    newState.newSessionForm.indexes = newSelected;
    setState(newState);
  };

  const getSessionItem = (id, type) => {
    let sessionItem = null
    personalSequences.forEach((personalSequenceGroup) => {
      sessionItem ||= personalSequenceGroup.items.find((item) => item.id == id && item.type == type);
    })
    return sessionItem;
  };

  const clickOnDelete = (e, index) => {
    e.stopPropagation();
    const deleteUrl = `${rental.sessionsUrl}?personal_sequence_id=-1&personal_sequence_type=-1&sessions_indexes[]=${index}`;
    clickOnSession(index, false);
    callApi(deleteUrl, "PATCH", "", () => {
      refresh();
    });
  };

  const renderSession = (session) => {
    const { index } = session;
    let rootClass = `${session.personal_sequence_id !== -1 ? style.active : ""
      } ${style.sessionLine}`;
    const sessionSelect = state.newSessionForm.indexes.includes(index);
    let sessionStatusClass = ``
    if (sessionSelect) {
      rootClass += ` ${style.selected}`;
    }
    if (session.done || session.skipped) {
      rootClass += ` ${style.noInteraction}`;
      if (session.done) {
        sessionStatusClass = `${style.done}`
      } else {
        sessionStatusClass = `${style.skipped}`
      }
    }
    if (isReacts) {
      rootClass += ` ${style.reactsSession}`
    }
    const sessionItem = getSessionItem(session.personal_sequence_id, session.personal_sequence_type);
    const code =
      sessionItem && session.personal_sequence_id !== -1
        ? sessionItem.code
        : "";
    return (
      <div
        className={rootClass}
        onClick={() =>
          session.done ? null : clickOnSession(index, !sessionSelect)
        }
        key={`session-horizontal-${session.personal_sequence_id}-${index}}`}
      >
        <div className={`${style.sessionCounter}`}>{session.counter}</div>
        <div className={`${style.sessionVisualizer}`}>{code}</div>
        <div
          className={`${session.done || session.skipped ? sessionStatusClass : style.deleteButton}`}
          onClick={session.done ? null : (e) => clickOnDelete(e, index)}
        />
      </div>
    );
  };

  const sessionListStyle = isReacts ? { width: "70%" } : { width: "100%" }

  return (
    <div className={`${style.SessionListContainerHorizontal}`}>
      <div className={`${style.sessionList}`} style={sessionListStyle}>
        {rental.sessions.map((item) => {
          return renderSession(item);
        })}
      </div>
      {isReacts &&
        <div className={style.reactsMonths}>
          <div>{months.first}</div>
          <div>{months.second}</div>
          <div>{months.third}</div>
        </div>
      }
    </div>
  );
}

SessionListContainerHorizontal.propTypes = {};

SessionListContainerHorizontal.defaultProps = {};

export default SessionListContainerHorizontal;
